import EditPolicyPage from "pages/spin/shared/EditPolicyPage";

export default EditPolicyPage;
